<div class="about-area py-8 lg:py-24 mt-8">
  <div class="container mx-auto px-4 ">
    <div class="flex flex-wrap items-center">
      <!-- Images Section -->
      <div class="w-full md:w-6/12 flex flex-wrap gap-4">
        <div class="flex items-end mb-4">
          <div class="w-7/12 pr-4">
            <img
              [src]="aboutUs.images[0]"
              alt="Image 1"
              class="rounded-lg shadow-md"
            />
          </div>
            <div class="au-img-circle" style="width: 35%;">
              <img src="images/Star.png" alt="About Us" />
              <div class="star-content">
                  <div>+4</div>
                  <div>Successful <br>Years</div>
              </div>
          </div>          
        </div>
        <div class="flex items-start">
          <div class="w-4/12">
            <img
              [src]="aboutUs.images[1]"
              alt="Image 1"
              class="rounded-lg shadow-md"
            />
          </div>
          <div class="w-8/12 flex justify-center items-center ps-5">
            <img
              [src]="aboutUs.images[2]"
              alt="Image 2"
              class="w-full h-auto"
            />
          </div>
        </div>
      </div>

      <!-- Content Section -->
      <div class="w-full md:w-6/12 px-4 pt-6 lg:pt-0  about-content">
        <h2 class="title pb-3">{{ aboutUs.title }}</h2>
        <p class="description mb-5">{{ aboutUs.description }}</p>
        <ul class="space-y-4">
          <li
            *ngFor="let feature of aboutUs.features"
            class="flex items-center space-x-3 mb-3 "
          >
            <img [src]="feature.icon" alt="">
            <p class="details">{{ feature.description }}</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
